import {ActionState} from '@colonist/game-states'

export class ActionsThatCanBeCancelled {
    static actions: ActionState[] = [
        ActionState.None,
        ActionState.PlaceRoad,
        ActionState.PlaceSettlement,
        ActionState.PlaceCity,
        ActionState.PlaceShip,
        ActionState.PlaceCityWall,
        ActionState.Select2ResourcesForYearOfPlenty,
        ActionState.Select1ResourceForMonopoly,
        ActionState.SelectShipToMove,
        ActionState.MoveShip,
        ActionState.PlaceKnight,
        ActionState.UpgradeKnight,
        ActionState.ActivateKnight,
        ActionState.SelectKnightToTakeAction,
        ActionState.SelectKnightAction,
        ActionState.SelectPlayerForDeserter,
        ActionState.MasterMerchantSelectPlayer,
        ActionState.MerchantFleetSelectResource,
        ActionState.SelectTileProductionNumbersToSwap,
        ActionState.SpySelectPlayer,
        ActionState.CommodityMonopolySelectResource,
        ActionState.ResourceMonopolySelectResource,
    ]
}
